import type { StaticConsent, StaticLink } from '@shared/cards-config';

export const installmentsActivation = {
    consents: [] as StaticConsent[],
    links: [] as StaticLink[],
    collapsibleThreshold: 6,
    visibleCount: 4,
    showLinkDescription: false,
};
